import React from 'react';
import { useTranslation } from 'react-i18next';
import { displayDate, mergeClassNames } from '../../../../utils';
import styles from './CommercialEPDispatchTimeDisplay.css';
import { getDispatchTimeStatus } from '../../../../utils/dispatchTime';

interface CommercialEPDispatchTimeDisplayProps {
  dispatchTime?: string | null;
}

const CommercialEPDispatchTimeDisplay: React.FC<CommercialEPDispatchTimeDisplayProps> = ({
  dispatchTime,
}) => {
  const { t } = useTranslation();
  if (!dispatchTime) {
    return <div className={styles.timeContainer}>{t('TO_BE_DETERMINED')}</div>
  }
  
  const dispatchDateFormatted = displayDate({ date: dispatchTime });
  const [dispatchDatePart, dispatchTimePart] = dispatchDateFormatted.split('-');
  const dispatchTimeStatus = getDispatchTimeStatus(dispatchTime);
  const { isDueSoon, isOverdue } = dispatchTimeStatus;
  const dispatchTimeClassNames = mergeClassNames(
    styles.dispatchTime,
    isDueSoon ? styles.dispatchDueSoon : '',
    isOverdue ? styles.dispatchOverdue : '',
  );

  return (
    <div className={styles.timeContainer}>
        <span className={styles.textLight}>{dispatchDatePart}</span>
        <span className={dispatchTimeClassNames}>{dispatchTimePart} 
          <span>{isOverdue ? t('LATE') : ''}</span>
        </span>
    </div>
  );
};

export default CommercialEPDispatchTimeDisplay;